// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-breadcrumb-container {
  margin-top: var(--spacing-extra-small);
}
.category-breadcrumb-container .breadcrumb {
  display: flex;
}
.category-breadcrumb-container .breadcrumb .item {
  font-family: var(--font-family);
  font-weight: 500;
  color: var(--color-neutral-dark-lighter);
  white-space: pre;
}
@media (max-width: 475px) {
  .category-breadcrumb-container .breadcrumb .item {
    font-size: var(--font-medium);
  }
}
@media (max-width: 375px) {
  .category-breadcrumb-container .breadcrumb {
    flex-direction: column;
    gap: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Product/CategoryBreadcrumb/CategoryBreadcrumb.less"],"names":[],"mappings":"AAAA;EACE,sCAAA;AACF;AAFA;EAII,aAAA;AACJ;AALA;EAOM,+BAAA;EACA,gBAAA;EACA,wCAAA;EAEA,gBAAA;AAAN;AAEM;EAAA;IACE,6BAAA;EACN;AACF;AAEI;EAAA;IACE,sBAAA;IACA,QAAA;EACJ;AACF","sourcesContent":[".category-breadcrumb-container {\n  margin-top: var(--spacing-extra-small);\n\n  .breadcrumb  {\n    display: flex;\n\n    .item {\n      font-family: var(--font-family);\n      font-weight: 500;\n      color: var(--color-neutral-dark-lighter);\n\n      white-space: pre;\n\n      @media (max-width: 475px) {\n        font-size: var(--font-medium);\n      }\n    }\n\n    @media (max-width: 375px) {\n      flex-direction: column;\n      gap: 4px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
